import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ViewContainer from '../common/components/Container/Container';
import { FlowConfigContext } from '../providers/FlowConfigContext';
import Loading from '../common/components/Loading/Loading';
import { Provider } from '../config';
import { Routes } from '../config/routes';
import { AuthenticationContext } from '../providers/AuthenticationContext';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { Screens } from '../services/analytics/screens';

function AuthenticationOnlyScreen(): JSX.Element {
  const { isLoggedIn } = useContext(AuthenticationContext);
  const { initialized, selectProvider } = useContext(FlowConfigContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!initialized) {
      return;
    }

    // If the given chain supports the authentication flow, then perform login if needed
    if (!isLoggedIn()) {
      selectProvider(Provider.WEB);
      navigate(Routes.LOGIN);
      return;
    }

    // Otherwise end the flow and emit the success event
    navigate(Routes.NO_FLOW);
  }, [initialized]);

  return (
    <ViewContainer>
      <div className="document-fixed-height flex h-screen justify-center items-center">
        <Loading dataTestId="IN_PROGRESS" />
      </div>
    </ViewContainer>
  );
}
export default withRouteAnalytics(AuthenticationOnlyScreen, Screens.AUTHENTICATION);
